import { Observable } from 'rxjs/Observable';
import { SecurityService } from 'app/security/security.service';
import { AppSettings } from './../../shared/app-settings';
import { AuthService } from './../../auth/auth.service';
import { EnrollmentProgramsService } from './../../shared/services/enrollment-programs.service';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { LoginAndRegisterComponent } from './login-and-register/login-and-register.component';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
import { UserProfileComponent } from 'app/security/security/user-profile/user-profile.component';
import { ProgramStatementsModel } from 'app/shared/models/program-statements.model';

@Component({
  selector: 'online-app-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.scss']
})
export class SecurityComponent implements OnInit {

  private _enrollmentType: string;

  protected isBackButton: boolean;

  protected topText: string;

  protected backButtonPath: string;

  protected isLoginRegisterPage:boolean=false;

  constructor(private authSer: AuthService,
    private router: Router,
    private _secService: SecurityService,
    public toastr: ToastsManager,
    private activatedRoute: ActivatedRoute,
    private _enrolleeProgramService: EnrollmentProgramsService) {

  }

  public imageUrl: Observable<string>;


  public onActivate(e) {
    if (e instanceof LoginAndRegisterComponent) {
      this.initLoginRegisterComponent();
    }
    else if (e instanceof ResetPasswordComponent) {
      this.isBackButton = true;
      this.topText = 'Change Password Page';
    }
    else if (e instanceof ForgotPasswordComponent) {
      this.topText = 'Forgot Password Page';
    }
    else {
      this.isBackButton = false;
      this.topText = null;
    }

    if (e instanceof ResetPasswordComponent || e instanceof UserProfileComponent)
      this.imageUrl = Observable.of(`${AppSettings.blobsStorage}/${this._secService.currentUserInfo.backgroundImgId}`);
    else if (!(e instanceof LoginAndRegisterComponent))
      this.imageUrl = Observable.of(AppSettings.onlineAppLogoPath);

    if (this.authSer.isAuthenticated())
      this.backButtonPath = '/stages';
    else
      this.backButtonPath = '/security/login';

      this.isLoginRegisterPage=e instanceof LoginAndRegisterComponent;
  }

  public get LoginStatementBefore(): Observable<string> {
    return this._enrolleeProgramService.getLoginStatementBefore();
  }

  public get CutOffMessage(): Observable<string> {
    return this._enrolleeProgramService.getCutOffMessage();
  }
  public get IsLoginHidden(): Observable<boolean> {
    return this._enrolleeProgramService.getIsLoginHidden();
  }

  public get IsRegisterHidden(): Observable<boolean> {
    return this._enrolleeProgramService.getIsRegisterHidden();
  }

  public ngOnInit() {
    if (this.authSer.isAuthenticated() && this.router.url == '/security/login')
      this.router.navigate(['stages'])
  }

  private initLoginRegisterComponent() {
    this._enrollmentType = this.activatedRoute.snapshot.firstChild.params['type'];
    this._enrolleeProgramService.getEnrolleProgramByAlias(this._enrollmentType).subscribe(item => {
      if (!item)
        this.toastr.error(`Cannot load program with alias ${this._enrollmentType}`);
      this.topText = `Access ${item.programTitle} Application`;
      this.isBackButton = true;
    });
    this.imageUrl = this._enrolleeProgramService.getBackgroundImageUrl(this._enrollmentType);
  }
}



// WEBPACK FOOTER //
// ./src/app/security/security/security.component.ts